export const DisplayRecordoptions = [
  { key: 1, text: "10", value: 10 },
  { key: 2, text: "20", value: 20 },
  { key: 3, text: "50", value: 50 },
  { key: 4, text: "100", value: 100 }
];
export const toastCutomId = {
  toastErrorId: null,
  toastSuccessId: null,
  toastWarningId: null
};
export const RelationOptions = getRelations();

function getRelations() {
  const relations = ["Father", "Mother", "Spouse", "Sibling"];
  var relationsArray = [];
  for (let i = 0; i < relations.length; i++) {
    let val = relations[i];
    relationsArray.push({ key: i + 1, text: val, value: val });
  }

  return relationsArray;
}

export const DegreeOptions = getDegrees();

function getDegrees() {
  const degrees = ["Matric", "Intermediate", "Graduation", "Masters", "PHD"];
  var degreesArray = [];
  for (let i = 0; i < degrees.length; i++) {
    let val = degrees[i];
    degreesArray.push({ key: val, text: val, value: val, name: val });
  }

  return degreesArray;
}

const mr = "Mr.";
const mrs = "Mrs.";
const miss = "Miss.";
const title = "Title";
export const TitleOptions = [
  { key: mr, text: mr, value: mr, name: title },
  { key: mrs, text: mrs, value: mrs, name: title },
  { key: miss, text: miss, value: miss, name: title }
];

const loanplanOne = "Loan Plan One";
const loanplanTwo = "Loan Plan Two";
const studentloanplan = "StudentLoanPlan";
export const LoanOptions = [
  {
    key: loanplanOne,
    text: loanplanOne,
    value: loanplanOne,
    name: studentloanplan
  },
  {
    key: loanplanTwo,
    text: loanplanTwo,
    value: loanplanTwo,
    name: studentloanplan
  }
];

const emergency = "Emergency";
const holidy = "Holidy";
const absent = "Absent.";

export const LeaveTypeOptions = [
  { key: emergency, text: emergency, value: emergency, name: emergency },
  { key: holidy, text: holidy, value: holidy, name: holidy },
  { key: absent, text: absent, value: absent, name: absent }
];

const yes = "Yes";
const no = "No";
const repaidloanplan = "RepaidLoanPlan";
export const LoanRepaidOptions = [
  { key: yes, text: yes, value: yes, name: repaidloanplan },
  { key: no, text: no, value: no, name: repaidloanplan }
];

const male = "Male";
const female = "Female";
const gender = "Gender";
export const GenderOptions = [
  { key: male, text: male, value: male, name: gender },
  { key: female, text: female, value: female, name: gender }
];

const single = "Single";
const married = "Married";
const maritalStatus = "MaritalStatus";
export const MeritalStatusOptions = [
  { key: single, text: single, value: single, name: maritalStatus },
  { key: married, text: married, value: married, name: maritalStatus }
];

const beginner = "Beginner";
const intermediate = "Intermediate";
const expert = "Expert";
const level = "Level";

export const LevelsOptions = [
  { key: beginner, text: beginner, value: beginner, name: level },
  {
    key: intermediate,
    text: intermediate,
    value: intermediate,
    name: level
  },
  { key: expert, text: expert, value: expert, name: level }
];

export const BloodOptions = getBloodGroups();

function getBloodGroups() {
  const bGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
  var groupsArray = [];
  for (let i = 0; i < bGroups.length; i++) {
    let val = bGroups[i];
    groupsArray.push({ key: val, text: val, value: val, name: val });
  }

  return groupsArray;
}

export const YearsOptions = getYears();

function getYears() {
  let currentYear = new Date().getFullYear();
  let yearsArray = [];
  for (let i = 2000; i <= currentYear; i++) {
    yearsArray.push({
      key: i,
      text: i.toString(),
      value: i,
      name: "CompletedYear"
    });
  }
  return yearsArray.reverse();
}

export const levelOptions = getLevels();

function getLevels() {
  const levels = [
    "Intern 1",
    "Intern 2",
    "Engineer 1",
    "Engineer 2",
    "Engineer 3",
    "Engineer 4",
    "Engineer 5",
    "Senior 1",
    "Senior 2",
    "Senior 3",
    "Senior 4",
    "Senior 5",
    "Lead 1",
    "Lead 2",
    "Lead 3",
    "Lead 4",
    "Lead 5",
    "Principle 1",
    "Principle 2",
    "Principle 3",
    "Principle 4",
    "Principle 5"
  ];
  var levelsArray = [];
  for (let i = 0; i < levels.length; i++) {
    let val = levels[i];
    levelsArray.push({ key: val, text: val, value: val, name: level });
  }

  return levelsArray;
}

const contractual = "Contractual";
const confirm = "Confirm";

// Pricing Constants
export const DEFAULT_PRICE_PER_USER_PER_MONTH = 1.45;
const employeeStatus = "EmployeeStatus";

export const employeeStatusOptions = [
  {
    key: contractual,
    text: contractual,
    value: contractual,
    name: employeeStatus
  },
  { key: confirm, text: confirm, value: confirm, name: employeeStatus }
];

export const masking = {
  MobileMask: "9999-9999999",
  phoneMask: "999 999 99999",
  CNICMask: "99999-9999999-9",
  NTNMask: "9999999-9"
};
export const GlobalKey = {
  accessKeyId: "AKIAI2RS664FU7CNEASQ",
  secretAccessKey: "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",
  Bucket: "hrm-ireland",
  ACL: "public-read",
  bucketUrl: "https://hrm-ireland.s3.amazonaws.com/"
};
export const constant = {
  Disability: "Disability",
  FacilitiesMessage: "Only two facilities can be selected.",
  Yes: true,
  AlphaRegEx: /^[a-zA-Z\b ]*$/, // Regex that allow only to enter  Char with Space
  EmailRegEx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NumRegex: /^[0-9]+$/, // Allow only numbers
  AlphaNumericRegEx: /^[A-Za-z0-9]*$|^[A-Za-z0-9][A-Za-z0-9]*[A-Za-z0-9]$/, // Allow only numbers plus characters
  AlphaSpaceRegex: /^[a-zA-Z\s-]+$/, // Allow only characters and spaces
  emailRegEx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,50}))$/,
  passRegEx: /^((?!.*[\s])([A-Za-z0-9][A-Za-z0-9]*(?:_[A-Za-z0-9]+)*).{2,50})$/,
  experienceRegex: /^\d{1,2}(?:\.\d{1,2})?$/,
  AlphaPlusSomeSpecialCharRegex: /^[ A-Za-z_@.,!/#&+-]*$/,
  deplayTiming: 300,
  PERSONAL_INFO: "Personal Info",
  EMPLOYEE_DETAIL: "Employee Detail",
  CONTACT_INFO: "Emergency Contact",
  EDUCATION: "Education",
  FAMILY_DETAILS: "Family Details",
  SKILLS: "Skills",
  WORK_HISTORY: "Work History",
  OTHERS: "Others",
  MIN_AGE: 15,
  UkPostalCode: /^([A-PR-UWYZa-pr-uwyz](([0-9](([0-9]|[A-HJKSTUWa-hjkstuw])?)?)|([A-HK-Ya-hk-y][0-9]([0-9]|[ABEHMNPRVWXYabehmnprvwxy])?)) [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/
};

export const LocalStorage = {
  state: "state",
  userInfo: "userInfo",
  selectedCompany: "selectedCompany",
  selectedOffice: "selectedOffice",
  currentEmployee: "currentEmployee",
  yearEmpLeaves: "yearEmpLeaves",
  leaveTypes: "leaveTypes",
  employeeId: "EmployeeId"
};
export const DateFormat = {
  DDMMYYY: "DD-MM-YYYY"
};
export const WeekEnds = {
  Saturday: 6,
  Sunday: 0
};
